import { toast } from 'react-toastify';

const toastOptions = {
  position: "bottom-center",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
};

const ToastService = {
  success: (message) => {
    toast.success(message, toastOptions);
  },
  error: (message) => {
    toast.error(message, toastOptions);
  },
  info: (message) => {
    toast.info(message, toastOptions);
  },
  warn: (message) => {
    toast.warn(message, toastOptions);
  },
};

export default ToastService;
